import React from 'react';
import SimpleTable from 'modules/Tables/SimpleTable';

const tableHeaders = [
  {
    Header: '',
    accessor: 'type'
  },
  {
    Header: '',
    accessor: 'value'
  },
];

const PepTable = ({ screening }) => {
  return (
    <>
      {(screening?.result?.hits && Array.isArray(screening.result.hits)) ? screening.result.hits.map((hit) => {
        return (
          <div className='s-bottom-l'>
            <SimpleTable
              headers={tableHeaders}
              data={[
                {
                  type: 'PEP',
                  value: hit?.pep ? 'Yes' : 'No'
                },
                {
                  type: 'Birtdate',
                  value: hit?.birthDate ? hit.birthDate : 'N/A'
                },
                {
                  type: 'Names',
                  value: hit?.names && Array.isArray(hit.names) ? hit.names.map((name) => `${name.firstName} ${name.lastName}`).join(', ') : 'N/A'
                },
                {
                  type: 'Country',
                  value: hit?.pepCountries ? hit.pepCountries : 'N/A'
                },
                {
                  type: 'Relations',
                  value: hit?.relations ? hit.relations.map(relation => relation.relationType).join(', ') : 'N/A'
                },
                {
                  type: 'Base role category name',
                  value: hit?.roles ? hit.roles.map(role => role.baseRoleCategoryName).join(', ') : 'N/A'
                },
                {
                  type: 'Detailed role category name',
                  value: hit?.roles ? hit.roles.map(role => role.detailedRoleCategoryName).join(', ') : 'N/A'
                },
                {
                  type: 'Role descriptions',
                  value: hit?.roles ? hit.roles.map(role => role.roleDescription).join(', ') : 'N/A'
                },
                {
                  type: 'Country of jurisdiction',
                  value: hit?.roles ? hit.roles.map(role => role.countryOfJurisdiction).join(', ') : 'N/A'
                },
                {
                  type: 'SSN',
                  value: hit?.ssns ? hit.ssns.map(ssn => `${ssn.currentSsn} (${ssn.ssnType})`).join(', ') : 'N/A'
                }
              ]}
            />
          </div>
        )
      }) : <p>No hits found</p>}
    </>
  )
};

export default PepTable;